module.exports = __webpack_public_path__ + "img/janet.e9e19d2c.png";